export const host = "https://dacnpm-bk-pass.vercel.app";
export const registerRoute = `${host}/api/register`
export const loginRoute = `${host}/api/login`
export const addItemRoute = `${host}/api/add-item`
export const getItemRoute = `${host}/api/get-item`